"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroupExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/radio/examples/radio-group.ts';
var RadioGroupExample = /** @class */ (function () {
    function RadioGroupExample() {
        this.options = ['First', 'Second', 'Third'];
        this.selected = 'Second';
    }
    RadioGroupExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.RadioGroup, {
                options: this.options,
                value: this.selected,
                onchange: function (e) { return _this.selected = e.currentTarget.value; }
            })
        ]);
    };
    return RadioGroupExample;
}());
exports.RadioGroupExample = RadioGroupExample;
